export default __webpack_public_path__ + "static/SRUS SP50 - Product Specifications & Technical Data-3c49a563848d2b51a6dac422c5dea01c.pdf";